export const aboutData = {
    title: "Who I am",
    description1: "My name is Ananya Das . I'm a software developer based in Kendrapara, Odisha.",
    description2: "During my work  time i work on Angular and Frontend Technologies projects . im interested in software developer are with learning of new technology.",
    image: 2
}